import React, { useEffect, useRef, useState } from 'react';
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from '@/components/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';
import { clsx } from 'clsx';
import styled from 'styled-components';

type ContentProps = {
  className?: string;
};

const SlidesData = [
  {
    id: 1,
    image: '/img/freshdesk-integration/main-image-1.webp',
    imageMobile: '/img/freshdesk-integration/main-image-1-mobile.webp',
    title: 'freshdesk-integration-main-image-1',
  },
  {
    id: 2,
    image: '/img/freshdesk-integration/main-image-2.webp',
    imageMobile: '/img/freshdesk-integration/main-image-2-mobile.webp',
    title: 'freshdesk-integration-main-image-2',
  },
];

const StyledImage = styled.img({
  filter: 'drop-shadow(-5px 10px 15px #000000)',
});
const StyledImageLogo = styled.img({
  filter: 'drop-shadow(-5px 5px 10px #000000)',
});

export const SwiperFreshdeskMain = ({ className }: ContentProps) => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  const plugin = useRef(Autoplay({ delay: 10000 }));

  useEffect(() => {
    if (!api) {
      return;
    }
    setCurrent(api.selectedScrollSnap() + 1);

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  return (
    <div className={className}>
      <Carousel plugins={[plugin.current]} setApi={setApi}>
        <CarouselContent>
          {SlidesData.map((slide, index) => (
            <CarouselItem key={`${slide.id}-${index}`}>
              <div
                className={clsx(
                  'flex justify-center relative lg:pt-5-vw lg:pb-10-vw lg:pl-12-vw lg:pr-5-vw p-10'
                )}
              >
                <div className="relative">
                  <picture
                    className={clsx(
                      'lg:max-w-[41.042vw] lg:max-h-[35.972vw] lg:w-[41.042vw] lg:h-[35.972vw] object-contain object-center'
                    )}
                  >
                    <source srcSet={slide.image} media="(min-width: 1024px)" />
                    <StyledImage
                      className="h-full w-full lg:max-w-[41.042vw] lg:max-h-[35.972vw] lg:h-[35.972vw] object-contain object-center"
                      src={slide.imageMobile}
                      alt={`${slide.title} image`}
                    />
                  </picture>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <div className="flex gap-4 justify-center text-center text-sm text-muted-foreground">
        {SlidesData.map((slide, index) => (
          <div
            onClick={() => api?.scrollTo(index)}
            key={`${slide.id}`}
            className={clsx(
              'md:h-[0.625vw] md:w-[0.625vw] h-[9px] w-[9px] bg-white rounded-full cursor-pointer',
              slide.id !== current && 'opacity-40'
            )}
          />
        ))}
      </div>
    </div>
  );
};
